import { Link, Text } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"

const InvalidVariable = ({ variable }) => {
  const { t, tc } = useTranslate()

  return (
    <Text color="inherit" m={0}>
      <div>
        <strong style={{ whiteSpace: "nowrap" }}>
          {t("Invalid variable")}:
        </strong>
      </div>
      {tc("this variable isn’t supported or may be spelled incorrectly.")}{" "}
      <Link
        color="inherit"
        variant="underline"
        href="https://help.pathwright.com/en/articles/4428159-use-variables-in-custom-reminders"
        target="_blank"
      >
        {t("Here’s a list of supported variables.")}
      </Link>
    </Text>
  )
}

InvalidVariable.displayName = "InvalidVariable"

export default InvalidVariable
